import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEO, { createWebPageSchema, createBreadcrumbSchema, createOrganizationSchema } from '../../components/feature/SEO';
import WhatsAppButton from '../../components/base/WhatsAppButton';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getImageUrl } from '../../utils/siteSettings';

const SERVICES_HERO_DEFAULT = 'https://public.readdy.ai/ai/img_res/f7fa856c8f5fd881a0eb6f4db22f3193.jpg';

const Services = () => {
  const { t } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://unqcode.com';

  const services = [
    {
      id: 'branding', icon: 'ri-palette-line',
      titleKey: 'svc.item1Title',
      shortDescKey: 'svc.item1Desc',
      longDescKey: 'srvPage.branding.longDesc',
      featureKeys: ['srvPage.branding.f1', 'srvPage.branding.f2', 'srvPage.branding.f3', 'srvPage.branding.f4', 'srvPage.branding.f5', 'srvPage.branding.f6'],
      image: 'https://readdy.ai/api/search-image?query=premium%20creative%20branding%20design%20studio%20with%20brand%20identity%20materials%20color%20palettes%20logo%20sketches%20on%20dark%20elegant%20table%2C%20professional%20design%20agency%20atmosphere%20with%20sophisticated%20warm%20lighting%2C%20close-up%20of%20design%20work%20on%20dark%20surface&width=640&height=480&seq=srv-brand02&orientation=landscape',
    },
    {
      id: 'web', icon: 'ri-code-s-slash-line',
      titleKey: 'svc.item2Title',
      shortDescKey: 'svc.item2Desc',
      longDescKey: 'srvPage.web.longDesc',
      featureKeys: ['srvPage.web.f1', 'srvPage.web.f2', 'srvPage.web.f3', 'srvPage.web.f4', 'srvPage.web.f5', 'srvPage.web.f6'],
      image: 'https://readdy.ai/api/search-image?query=professional%20web%20developer%20coding%20on%20multiple%20dark%20monitors%20with%20clean%20React%20code%20visible%2C%20premium%20developer%20workstation%20with%20mechanical%20keyboard%2C%20dark%20ambient%20room%20with%20subtle%20red%20LED%20glow%2C%20high-end%20tech%20workspace%20photography&width=640&height=480&seq=srv-web02&orientation=landscape',
    },
    {
      id: 'mobile', icon: 'ri-smartphone-line',
      titleKey: 'svc.item3Title',
      shortDescKey: 'svc.item3Desc',
      longDescKey: 'srvPage.mobile.longDesc',
      featureKeys: ['srvPage.mobile.f1', 'srvPage.mobile.f2', 'srvPage.mobile.f3', 'srvPage.mobile.f4', 'srvPage.mobile.f5', 'srvPage.mobile.f6'],
      image: 'https://readdy.ai/api/search-image?query=premium%20smartphone%20mockup%20displaying%20dark-themed%20mobile%20application%20interface%20with%20modern%20UI%20screens%2C%20elegant%20product%20photography%20on%20pure%20dark%20background%2C%20professional%20mobile%20app%20showcase%20with%20crisp%20screen%20details%2C%20minimalist%20tech%20advertising%20aesthetic&width=640&height=480&seq=srv-mobile02&orientation=landscape',
    },
    {
      id: 'ai', icon: 'ri-brain-line',
      titleKey: 'svc.item4Title',
      shortDescKey: 'svc.item4Desc',
      longDescKey: 'srvPage.ai.longDesc',
      featureKeys: ['srvPage.ai.f1', 'srvPage.ai.f2', 'srvPage.ai.f3', 'srvPage.ai.f4', 'srvPage.ai.f5', 'srvPage.ai.f6'],
      image: 'https://readdy.ai/api/search-image?query=stunning%20artificial%20intelligence%20neural%20network%203D%20visualization%20with%20glowing%20interconnected%20nodes%20and%20synaptic%20connections%20on%20deep%20dark%20background%2C%20vibrant%20crimson%20red%20energy%20pulses%20flowing%20through%20data%20pathways%2C%20futuristic%20machine%20learning%20concept%20art%2C%20dramatic%20sci-fi%20technology%20aesthetic&width=640&height=480&seq=srv-ai02&orientation=landscape',
    },
    {
      id: 'marketing', icon: 'ri-line-chart-line',
      titleKey: 'svc.item5Title',
      shortDescKey: 'svc.item5Desc',
      longDescKey: 'srvPage.marketing.longDesc',
      featureKeys: ['srvPage.marketing.f1', 'srvPage.marketing.f2', 'srvPage.marketing.f3', 'srvPage.marketing.f4', 'srvPage.marketing.f5', 'srvPage.marketing.f6'],
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20analytics%20command%20center%20with%20dark%20screens%20displaying%20real-time%20growth%20charts%20KPI%20dashboards%20and%20campaign%20performance%20data%2C%20professional%20business%20intelligence%20interface%20with%20red%20accent%20colors%2C%20modern%20data-driven%20marketing%20workspace%2C%20cinematic%20dark%20atmosphere&width=640&height=480&seq=srv-mkt02&orientation=landscape',
    },
    {
      id: 'consulting', icon: 'ri-settings-4-line',
      titleKey: 'svc.item6Title',
      shortDescKey: 'svc.item6Desc',
      longDescKey: 'srvPage.consulting.longDesc',
      featureKeys: ['srvPage.consulting.f1', 'srvPage.consulting.f2', 'srvPage.consulting.f3', 'srvPage.consulting.f4', 'srvPage.consulting.f5', 'srvPage.consulting.f6'],
      image: 'https://readdy.ai/api/search-image?query=premium%20IT%20consulting%20executive%20boardroom%20with%20digital%20strategy%20diagrams%20on%20dark%20glass%20wall%2C%20confident%20tech%20executives%20in%20professional%20attire%20engaged%20in%20strategic%20planning%20session%2C%20modern%20dark%20corporate%20interior%20with%20architectural%20lighting%20and%20red%20accent%20elements&width=640&height=480&seq=srv-consult02&orientation=landscape',
    },
  ];

  const [active, setActive] = useState(services[0].id);
  const activeService = services.find((s) => s.id === active)!;

  const processSteps = [
    { step: '01', icon: 'ri-discuss-line', titleKey: 'srvPage.process1Title', descKey: 'srvPage.process1Desc' },
    { step: '02', icon: 'ri-draft-line', titleKey: 'srvPage.process2Title', descKey: 'srvPage.process2Desc' },
    { step: '03', icon: 'ri-tools-line', titleKey: 'srvPage.process3Title', descKey: 'srvPage.process3Desc' },
    { step: '04', icon: 'ri-rocket-2-line', titleKey: 'srvPage.process4Title', descKey: 'srvPage.process4Desc' },
  ];

  const servicesSchema = [
    {
      id: 'branding',
      name: 'Branding & Design',
      description: 'Professional brand identity design including logo design, UI/UX design for web and mobile, brand guidelines, marketing materials, motion graphics, and social media visual kits for businesses in Saudi Arabia.',
      features: ['Logo Design & Brand Identity', 'UI/UX Design for Web & Mobile', 'Brand Guidelines & Style Guides', 'Marketing Materials & Print', 'Motion Graphics & Animation', 'Social Media Visual Kits'],
    },
    {
      id: 'web',
      name: 'Web Development',
      description: 'Custom website development, e-commerce stores, SaaS web applications, CMS integration, performance optimization, SEO, and API development for businesses across Saudi Arabia and the GCC.',
      features: ['Custom Website Development', 'E-Commerce & Online Stores', 'SaaS & Web Applications', 'CMS Integration', 'Performance Optimization & SEO', 'API Development & Integration'],
    },
    {
      id: 'mobile',
      name: 'Mobile App Development',
      description: 'Native iOS and Android mobile app development, cross-platform React Native apps, App Store optimization, push notifications, analytics integration, and ongoing maintenance for Saudi businesses.',
      features: ['iOS (Swift) Development', 'Android (Kotlin) Development', 'Cross-Platform (React Native)', 'App Store Optimization', 'Push Notifications & Analytics', 'Maintenance & Version Updates'],
    },
    {
      id: 'ai',
      name: 'AI & Smart Technology',
      description: 'Custom AI and machine learning model development, intelligent chatbots, data analytics, robotic process automation (RPA), computer vision solutions, and IoT smart systems integration.',
      features: ['Custom AI/ML Model Development', 'Intelligent Chatbots & Assistants', 'Data Analytics & Visualization', 'Process Automation (RPA)', 'Computer Vision Solutions', 'IoT & Smart Systems Integration'],
    },
    {
      id: 'marketing',
      name: 'Digital Marketing',
      description: 'Data-driven digital marketing including SEO, social media management, Google and Meta paid ads, content marketing strategy, email campaigns, and our unique revenue-sharing marketing model.',
      features: ['SEO & Search Marketing', 'Social Media Management', 'Paid Ads (Google, Meta)', 'Content Marketing Strategy', 'Email Campaigns & Automation', 'Revenue-Sharing Marketing Model'],
    },
    {
      id: 'consulting',
      name: 'IT Consulting',
      description: 'Strategic IT consulting services including technology audits, digital transformation roadmaps, cloud migration strategy, cybersecurity consulting, team training, and vendor selection for enterprises.',
      features: ['Technology Audit & Assessment', 'Digital Transformation Roadmap', 'Cloud Migration Strategy', 'Cybersecurity Consulting', 'Team Training & Upskilling', 'Vendor & Platform Selection'],
    },
  ];

  const fullSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      // WebPage
      createWebPageSchema(
        t('seo.servicesTitle'),
        t('seo.servicesDesc'),
        '/services'
      ),
      // Organization
      createOrganizationSchema(),
      // BreadcrumbList
      createBreadcrumbSchema([
        { name: 'Home', url: '/' },
        { name: 'Services', url: '/services' },
      ]),
      // ItemList — enables Google rich results listing all services
      {
        '@type': 'ItemList',
        name: 'Unique Code Services',
        description: 'Full suite of digital technology services offered by Unique Code in Saudi Arabia',
        url: `${siteUrl}/services`,
        numberOfItems: servicesSchema.length,
        itemListElement: servicesSchema.map((svc, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: svc.name,
          url: `${siteUrl}/services`,
          item: {
            '@type': 'Service',
            '@id': `${siteUrl}/services#${svc.id}`,
            name: svc.name,
            description: svc.description,
            serviceType: svc.name,
            url: `${siteUrl}/services`,
            provider: {
              '@type': 'Organization',
              name: 'Unique Code',
              url: siteUrl,
              logo: `${siteUrl}/logo-dark.png`,
              telephone: '+966552099231',
              email: 'Info@unqcode.com',
            },
            areaServed: [
              { '@type': 'Country', name: 'Saudi Arabia' },
              { '@type': 'Country', name: 'United Arab Emirates' },
              { '@type': 'AdministrativeArea', name: 'GCC' },
            ],
            hasOfferCatalog: {
              '@type': 'OfferCatalog',
              name: `${svc.name} Features`,
              itemListElement: svc.features.map((feature) => ({
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: feature,
                },
              })),
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.9',
              reviewCount: '120',
              bestRating: '5',
              worstRating: '1',
            },
          },
        })),
      },
      // HowTo — process steps for rich results
      {
        '@type': 'HowTo',
        name: 'How Unique Code Delivers Digital Projects',
        description: 'Our proven 4-step process for delivering world-class digital products on time and on budget.',
        url: `${siteUrl}/services`,
        totalTime: 'P3M',
        supply: [
          { '@type': 'HowToSupply', name: 'Project Requirements' },
          { '@type': 'HowToSupply', name: 'Business Goals & KPIs' },
        ],
        tool: [
          { '@type': 'HowToTool', name: 'React & TypeScript' },
          { '@type': 'HowToTool', name: 'AI & Machine Learning' },
          { '@type': 'HowToTool', name: 'Cloud Infrastructure' },
        ],
        step: [
          {
            '@type': 'HowToStep',
            position: 1,
            name: 'Discovery',
            text: 'We start by deeply understanding your business, goals, and challenges through structured discovery sessions.',
            url: `${siteUrl}/services#process`,
          },
          {
            '@type': 'HowToStep',
            position: 2,
            name: 'Strategy',
            text: 'Our team creates a tailored roadmap with clear milestones, technologies, and expected outcomes.',
            url: `${siteUrl}/services#process`,
          },
          {
            '@type': 'HowToStep',
            position: 3,
            name: 'Build',
            text: 'We execute with precision — iterative sprints, regular demos, and full transparency throughout development.',
            url: `${siteUrl}/services#process`,
          },
          {
            '@type': 'HowToStep',
            position: 4,
            name: 'Launch & Scale',
            text: 'We deploy, monitor, optimize, and support your product long after launch for continued growth.',
            url: `${siteUrl}/services#process`,
          },
        ],
      },
    ],
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEO
        title={t('seo.servicesTitle')}
        description={t('seo.servicesDesc')}
        keywords="web development services, mobile app development, AI solutions, digital marketing, branding services, IT consulting Saudi Arabia, خدمات تطوير المواقع, تطبيقات الجوال, الذكاء الاصطناعي"
        canonical={`${siteUrl}/services`}
        ogType="website"
        schema={fullSchema}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gray-900 overflow-hidden">
        <div className="absolute inset-0">
          <img src={getImageUrl('hero-services', SERVICES_HERO_DEFAULT)} alt="Services" width={1280} height={500} className="w-full h-full object-cover object-top opacity-25" fetchPriority="high" decoding="async" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 to-gray-900"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-brand-red font-bold text-sm uppercase tracking-widest mb-4">{t('srvPage.heroLabel')}</p>
          <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-6">
            {t('srvPage.heroTitle1')} <span className="text-brand-red">{t('srvPage.heroTitle2')}</span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">{t('srvPage.heroDesc')}</p>
        </div>
      </section>

      {/* Interactive Services Detail */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-72 flex-shrink-0">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 ps-3">{t('srvPage.selectLabel')}</p>
              <div className="space-y-1">
                {services.map((s) => (
                  <button
                    key={s.id}
                    onClick={() => setActive(s.id)}
                    className={`w-full flex items-center gap-3 px-4 py-4 rounded-xl text-left transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      active === s.id ? 'bg-brand-red text-white' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                  >
                    <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${active === s.id ? 'bg-white/20' : 'bg-gray-100'}`}>
                      <i className={`${s.icon} text-lg ${active === s.id ? 'text-white' : 'text-gray-500'}`}></i>
                    </div>
                    <span className="font-semibold text-sm">{t(s.titleKey)}</span>
                    {active === s.id && <i className="ri-arrow-right-s-line rtl:rotate-180 ms-auto text-lg"></i>}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="rounded-3xl overflow-hidden h-72 md:h-80 mb-8 relative">
                <img
                  src={activeService.image}
                  alt={t(activeService.titleKey)}
                  key={activeService.id}
                  width={640}
                  height={480}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-6 start-8">
                  <span className="inline-block px-3 py-1 bg-brand-red text-white text-xs font-bold rounded-full uppercase tracking-wide mb-2">
                    {t(activeService.titleKey)}
                  </span>
                </div>
              </div>
              <div className="grid lg:grid-cols-2 gap-10">
                <div>
                  <h2 className="text-3xl font-black text-gray-900 mb-4">{t(activeService.titleKey)}</h2>
                  <p className="text-gray-500 leading-relaxed mb-6">{t(activeService.longDescKey)}</p>
                  <Link to="/contact">
                    <button className="px-7 py-3.5 bg-brand-red text-white font-bold rounded-xl hover:bg-brand-red-dark transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2">
                      {t('srvPage.getQuote')} <i className="ri-arrow-right-line rtl:rotate-180"></i>
                    </button>
                  </Link>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-5">{t('srvPage.whatsIncluded')}</h3>
                  <ul className="space-y-3">
                    {activeService.featureKeys.map((fKey) => (
                      <li key={fKey} className="flex items-center gap-3 text-gray-700">
                        <div className="w-5 h-5 flex items-center justify-center bg-brand-red/10 rounded-full flex-shrink-0">
                          <i className="ri-check-line text-brand-red text-xs"></i>
                        </div>
                        <span className="text-sm">{t(fKey)}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-24 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <p className="text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">{t('srvPage.processLabel')}</p>
            <h2 className="text-4xl font-black text-white">{t('srvPage.processTitle')}</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((p) => (
              <div key={p.step} className="relative">
                <div className="text-6xl font-black text-white/5 absolute -top-4 -start-2 select-none">{p.step}</div>
                <div className="relative pt-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-brand-red rounded-xl mb-5">
                    <i className={`${p.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="font-bold text-white text-lg mb-3">{t(p.titleKey)}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{t(p.descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-5">{t('srvPage.ctaTitle')}</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto mb-10">{t('srvPage.ctaDesc')}</p>
          <Link to="/contact">
            <button className="px-10 py-4 bg-brand-red text-white font-bold rounded-xl text-lg hover:bg-brand-red-dark transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer">
              {t('srvPage.ctaBtn')}
            </button>
          </Link>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Services;
